import { sliderAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react'
import { mode } from '@chakra-ui/theme-tools'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(sliderAnatomy.keys)

const baseStyleTrack = defineStyle(props => {
  const { colorScheme } = props

  return {
    bg: `${colorScheme}.300`,
  }
})

const baseStyleFilledTrack = defineStyle(props => {
  const { colorScheme } = props

  return {
    bg: `${colorScheme}.500`,
  }
})

const baseStyleThumb = defineStyle(props => {
  const { colorScheme } = props

  return {
    bg: `${colorScheme}.500`,
    borderStyle: `solid`,
    boxSize: 5,
    borderWidth: `1px`,
    borderColor: `${mode(`whiteAlpha.200`, `blackAlpha.200`)(props)}`,
  }
})

const baseStyle = definePartsStyle(props => ({
  track: baseStyleTrack(props),
  filledTrack: baseStyleFilledTrack(props),
  thumb: baseStyleThumb(props),
}))

export const Slider = defineMultiStyleConfig({
  baseStyle,
  defaultProps: {
    colorScheme: 'brand',
  },
})
